import styled from 'styled-components';

export const FilterWrapper = styled.div`
  padding: 20px 0px 30px 0px;
  .search-input {
    min-width:250px;
    height: 40px;
  }
`;

export const FilterContentWrapper = styled.div`
  .min-w-150 {
    min-width: 150px;
  } 
  .min-w-180 {
    min-width: 180px;
  }
  .ant-form-item {
    margin-bottom: 0 !important;
  }
`;

export const ShowContentWrapper = styled.div`
.v-show-content {
  max-height: 50vh;
  overflow-y: auto;
}
.search-input {
  border:none;
  border-bottom: 1px solid var(--border-color);
}
.v-show-content {
  padding: 15px;
}
`;